import React, { useState, useEffect } from 'react';
import {
  AppBar, Toolbar, Box, 
} from '@mui/material';
import { Link } from 'react-router-dom';
import logo from '../assets/images/Logo-Eurobiomed.png';

const classes = {
  appBar: {
    backgroundColor: '#01AAAD',
    padding: '0 10%',
    '@media (max-width:768px)': {
      padding: '0 10px',
    },
  },
  list: {
    width: 200,
  },
  padding: {
    paddingRight: 30,
    cursor: 'pointer',
    fontSize: '16px',
    fontFamily: 'Lato, sans-serif',
    fontWeight: '400',
  },

  sideBarIcon: {
    padding: 0,
    color: 'black',
    cursor: 'pointer',
  },
};

function Navbar(props) {
  const [drawerActive, setDrawerActive] = useState(false);

  useEffect(() => {
    if (window.innerWidth <= 600) {
      setDrawerActive(true);
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 600) {
        setDrawerActive(true);
      } else {
        setDrawerActive(false);
      }
    });
  }, []);

  //Small Screens
  let createDrawer = () => {
    return (
      <div>
        <AppBar sx={classes.appBar} position='static'>
          <Toolbar>
            <Box sx={classes.mobileBar}>
              <Link style={classes.logoMobile} to='/'>
                <img style={{ height: '40px' }} src={logo} alt='lo'></img>
              </Link>
            </Box>
          </Toolbar>
        </AppBar>
      </div>
    );
  };

  //Larger Screens
  let destroyDrawer = () => {
    return (
      <AppBar sx={classes.appBar} position='sticky'>
        <Toolbar style={{ padding: 'unset' }}>
          <Box sx={classes.headerContainer}>
            <Link sx={classes.logoMobile} to='/'>
              <img style={{ height: '40px'}} src={logo} alt="logo" />
            </Link>
          </Box>
        </Toolbar>
      </AppBar>
    );
  };
  return <div>{drawerActive ? createDrawer() : destroyDrawer()}</div>;
}

export default Navbar;
